import { useTranslation } from "react-i18next";
import { Tag } from "@carbon/react";
import { SupplierRfqActivity } from "../../types";

/** Whether a buyer of the company validated this supplier. Nothing until that is known. */
const SupplierValidationTag = ({
  activity,
}: {
  activity?: SupplierRfqActivity;
}) => {
  const { t } = useTranslation();
  if (typeof activity?.validated !== "boolean") return null;

  return activity.validated ? (
    <Tag type="green" size="sm">
      {t("tenders.supplierActivity.validated")}
    </Tag>
  ) : (
    <Tag type="outline" size="sm">
      {t("tenders.supplierActivity.notValidated")}
    </Tag>
  );
};

export const activityByEmail = (activity: SupplierRfqActivity[] = []) =>
  new Map(activity.map((row) => [row.email.toLowerCase(), row]));

export default SupplierValidationTag;
